<template>
  <button class="cookie-comply__button" :class="className" @click="handleClick">
    <slot></slot>
  </button>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from 'vue'

interface Props {
  className?: string
}

// Definicja typu dla propsów
const props = defineProps<Props>()

// Definicja emitowanych zdarzeń
const emit = defineEmits<{
  (e: 'handleClick'): void
}>()

// Funkcja obsługująca kliknięcie
const handleClick = () => {
  emit('handleClick')
}
</script>
